class YoutubeChaptersSection extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.videoId = this.dataset.videoId;
    this.autoplay = this.dataset.autoplay === 'true';
    this.containerId = 'player-' + this.sectionId;
    this.player = null;
    this.sliderInstance = null;
    this.chaptersData = [];
    this.activeInterval = null;
    this.checkYTInterval = null;
  }

  connectedCallback() {
    this.initSlider();
    this.initYouTubePlayer();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  cleanup() {
    if (this.activeInterval) {
      clearInterval(this.activeInterval);
      this.activeInterval = null;
    }
    if (this.checkYTInterval) {
      clearInterval(this.checkYTInterval);
      this.checkYTInterval = null;
    }
    if (this.sliderInstance) {
      this.sliderInstance.destroy();
      this.sliderInstance = null;
    }
  }

  // --- Slider Logic ---
  initSlider() {
    var sliderContainer = document.getElementById('chapters-slider-' + this.sectionId);
    if (!sliderContainer) return;
    
    if (typeof KeenSlider === 'undefined') {
      setTimeout(() => this.initSlider(), 100);
      return;
    }

    this.sliderInstance = new KeenSlider(sliderContainer, {
      loop: false,
      slides: {
        perView: 2,
        spacing: 16,
      },
      breakpoints: {
        "(min-width: 768px)": {
          slides: { perView: 2.5, spacing: 24 },
        },
        "(min-width: 1024px)": {
          slides: { perView: 3, spacing: 16 },
        },
        "(min-width: 1400px)": {
           slides: { perView: 4, spacing: 16 },
        }
      }
    }); 
  }

  // --- YouTube Player Logic ---
  initYouTubePlayer() {
    if (!this.videoId) {
      console.warn('YouTube Chapters: No Video ID found');
      return;
    }

    if (!window.YT) {
      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    // Robust API Waiter
    this.checkYTInterval = setInterval(() => {
      if (window.YT && window.YT.Player) {
        clearInterval(this.checkYTInterval);
        this.createPlayer();
      }
    }, 100);

    setTimeout(() => {
      if (this.checkYTInterval) {
        clearInterval(this.checkYTInterval);
      }
    }, 10000);
  }

  createPlayer() {
    this.player = new YT.Player(this.containerId, {
      height: '100%',
      width: '100%',
      videoId: this.videoId,
      playerVars: {
        'playsinline': 1,
        'rel': 0,
        'autoplay': this.autoplay ? 1 : 0
      },
      events: {
        'onReady': this.onPlayerReady.bind(this),
        'onStateChange': this.onPlayerStateChange.bind(this)
      }
    });
  }

  parseTimestamp(timeString) {
    if (!timeString) return 0;
    var parts = timeString.split(':');
    if (parts.length === 2) {
      return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
    } else if (parts.length === 3) {
       return parseInt(parts[0], 10) * 3600 + parseInt(parts[1], 10) * 60 + parseInt(parts[2], 10);
    }
    return parseInt(timeString, 10); 
  }

  onPlayerReady(event) {
    var chapters = this.querySelectorAll('.chapter-item');
    this.chaptersData = [];

    chapters.forEach((chapter, index) => {
      var timestampStr = chapter.getAttribute('data-timestamp');
      var seconds = this.parseTimestamp(timestampStr);
      this.chaptersData.push({
        element: chapter,
        seconds: seconds,
        index: index
      });

      chapter.addEventListener('click', () => {
        var state = this.player.getPlayerState();
        if (state !== 1) { 
          this.player.playVideo();
        }
        this.player.seekTo(seconds, true);
        this.player.playVideo();
      });
    });

    // Start checking for active chapter
    this.startActiveCheck();
  }

  onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.PLAYING) {
      this.startActiveCheck();
    } else {
      this.stopActiveCheck();
    }
  }

  startActiveCheck() {
    this.stopActiveCheck();
    this.activeInterval = setInterval(() => this.highlightActiveChapter(), 1000);
    this.highlightActiveChapter(); // Immediate check
  }

  stopActiveCheck() {
    if (this.activeInterval) {
      clearInterval(this.activeInterval);
      this.activeInterval = null;
    }
  }

  highlightActiveChapter() {
    if (!this.player || typeof this.player.getCurrentTime !== 'function') return;
    
    var currentTime = this.player.getCurrentTime();
    var activeIndex = -1;

    // Find the latest chapter that is before or equal to current time
    for (var i = 0; i < this.chaptersData.length; i++) {
      if (currentTime >= this.chaptersData[i].seconds) {
        activeIndex = i;
      } else {
        break; // Optimized: assuming timestamps are sorted!
      }
    }

    // Update classes
    this.chaptersData.forEach((chap, idx) => {
      if (idx === activeIndex) {
        chap.element.classList.add('active-chapter');
      } else {
        chap.element.classList.remove('active-chapter');
      }
    });
  }
}

if (!customElements.get('youtube-chapters-section')) {
  customElements.define('youtube-chapters-section', YoutubeChaptersSection);
}
